var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-header"},[_c('div',{staticClass:"chat-title",on:{"click":function($event){return _vm.$emit('edit-title')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }